//Generator Url: http://localhost:8033/api/upload/getapi
import request from '@/utils/request';
//import './UploadApi.d';
export namespace UploadApi {
    /**获取上传会话*/
    export const getSession = (loadingOptions?: IRequestLoadingOption) => request<IUploadSessionResult>({
        method: 'post',
        url: 'Upload/GetSession',
        loadingOptions
    })

    /**文件上传(经Base64编码的文件)*/
    export const postBase64 = (param: IBase64FileParam, loadingOptions?: IRequestLoadingOption) => request<IUploadViewModelWithBarCodeInfo>({
        method: 'post',
        url: 'Upload/PostBase64',
        data: param,
        loadingOptions
    })

    export const getFiles = (param: IFileListParam, loadingOptions?: IRequestLoadingOption) => request<Array<IFileDetailView>>({
        method: 'post',
        url: 'Upload/GetFiles',
        data: param,
        loadingOptions
    })

    export const getSessionFiles = (param: ISessionFileListParam, loadingOptions?: IRequestLoadingOption) => request<Array<IFileDetailView>>({
        method: 'post',
        url: 'Upload/GetSessionFiles',
        data: param,
        loadingOptions
    })

    export const del = (model: IDeleteUploadFileRequest, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'post',
        url: 'Upload/Delete',
        data: model,
        loadingOptions
    })

    export const updateHideFiles = (model: IUpdateHideParam, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'post',
        url: 'Upload/UpdateHideFiles',
        data: model,
        loadingOptions
    })

    export const getImageFiles = (param: IUploadFilesParam, loadingOptions?: IRequestLoadingOption) => request<IFilesResult>({
        method: 'post',
        url: 'Upload/GetImageFiles',
        data: param,
        loadingOptions
    })

    export const takeText = (fileid: Array<NString>, loadingOptions?: IRequestLoadingOption) => request<Array<IPUB_UploadFileOCR>>({
        method: 'post',
        url: 'Upload/TakeText',
        data: fileid,
        loadingOptions
    })

    export const saveText = (param: IUpdateFieldParam, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'post',
        url: 'Upload/SaveText',
        data: param,
        loadingOptions
    })

    export const copyFiles = (arg: ICopyUploadFilesParam, loadingOptions?: IRequestLoadingOption) => request<number>({
        method: 'post',
        url: 'Upload/CopyFiles',
        data: arg,
        loadingOptions
    })

    // ------------ model define ------------- //


    export interface IUploadSessionResult {

        SessionId?: NString
    }


    export interface IUploadViewModel {

        Id?: NString
    }


    export const enum SimpleBarCodeFormat {
        Unknow = 0,
        /**1维条码*/
        BarCode = 1,
        /**2维码*/
        QRCode = 2
    }


    export interface IBarCodeInfo {

        Format: SimpleBarCodeFormat

        Text?: NString
    }


    export interface IUploadViewModelWithBarCodeInfo extends IUploadViewModel {
        /**条码信息
        *ZnlSoft.Scm.Core.Models.BarCode.BarCodeInfo[]*/
        BarCode: Array<IBarCodeInfo>
    }


    export interface IFileListParam {

        RelationId?: number
        /**关联类型
        *System.String*/
        RelationType?: NString

        RelationTypes?: Array<NString>

        RelationIds?: Array<number>
    }


    export const enum DetectBarcode {
        None = 0,
        /**必须存在，否则不保存文件*/
        MustExist = 1,
        /**允许保存无二维的文件内容*/
        Optional = 2
    }


    export interface IBase64FileParam extends IFileListParam {

        FileName?: NString

        Base64?: NString

        SessionId?: NString
        /**手动模式，不检查关联Id
        *System.Int32*/
        Demand: number
        /**是否转换成描述档
        *System.Boolean*/
        Document: boolean
        /**是否需要识别文件中的条码信息
        *ZnlSoft.Scm.Core.ParamModels.UploadFile.DetectBarcode*/
        DetectBarcode: DetectBarcode
    }


    export interface IWeiXinFileParam extends IFileListParam {
        /**媒体id
        *System.String*/
        ServerId?: NString

        SessionId?: NString
    }

    /**上传文件关联表类型的枚举
    *ZnlSoft.Scm.Core.Models.UploadFileTypes*/
    export const enum UploadFileTypes {
        Unknow = 0,
        /**进口订单随货装箱单*/
        agent_order_packaging = 1,
        /**进口订单随货发票*/
        agent_order_invoice = 2,
        /**付汇通知单 (委托书)*/
        payment_invoice = 3,
        /**前台提交的委托单附件*/
        per_agent_order = 4,
        /**小程序提交的税单PDF文件*/
        customs_order_tax = 6,
        /**服务协议附件*/
        client_contract = 7,
        /**本港单装箱单*/
        hk_agent_order_packagelist = 9,
        /**清关文件*/
        hk_clear_customs = 10,
        /**提货文件*/
        pickup_goods_files = 11,
        /**营业执照附件*/
        business_license = 17,
        /**开票资料附件*/
        invoice_information = 18,
        /**客户物料得规格书*/
        client_product_spec = 19,
        /**承运商附件*/
        carrier = 20,
        /**车辆排班*/
        vechicle_schedule = 21,
        /**香港入仓登记*/
        hk_warehouse_record = 22,
        /**付汇(水单)*/
        payment_invoice_files = 23,
        /**付款通知单*/
        payment_money_files = 24,
        /**付款(水单)*/
        payment_order_files = 25,
        /**本港单快递文件*/
        bg_express_files = 26,
        /**香港入仓登记提货费*/
        hk_warehouse_takefee = 27,
        /**入库单照片*/
        receipt_order_photo = 28,
        /**出库单照片*/
        out_order_photo = 29,
        /**出库单拍照照片*/
        out_order_camera = 30,
        /**出库单快递照片*/
        out_order_express_photo = 31,
        /**出库单标签*/
        out_order_label = 32,
        /**本港单发票*/
        hk_invoice_file = 40,
        /**本港装箱单*/
        hk_packing_file = 41,
        /**本港单处理标签*/
        hk_tag_img = 42,
        /**本港单发货发票*/
        bg_shipments_invoice = 43,
        /**本港单发货装箱单*/
        bg_shipments_packing = 44,
        /**本港出库单发货发票*/
        stockout_shipments_invoice = 45,
        /**本港出库单发货装箱单*/
        stockout_shipments_packing = 46,
        /**退款水单*/
        refund_order_files = 47,
        /**本港单处理标签-发货*/
        hk_tag_img_send = 48,
        /**出库单-货物签收单*/
        goods_sign_files = 49,
        /**出库单-送货费单*/
        stock_out_amount_files = 50,
        /**费用明细手工文件*/
        handle_charge_detail = 51,
        /**收货单验收单*/
        receipt_order_check = 52,
        /**3C目录证书文件*/
        certificate_files = 53,
        /**BOM.AI委托书*/
        bom_client = 54,
        /**收货付款授权书*/
        pay_authorization = 55,
        /**客户开票信息附件*/
        client_invoice = 56,
        /**香港付款通知单 (委托书)*/
        hkpayment_invoice = 57,
        /**香港付款(水单)*/
        hkpayment_invoice_files = 58,
        /**香港客户付款水单*/
        hkpayment_money_files = 59,
        /**管理目录证书文件*/
        certificate_manage_files = 60,
        /**其他图片*/
        other_image = 61,
        /**结算单回签*/
        quotation_sheet_back = 62,
        /**收款登记附件*/
        payment_register = 63,
        /**供应商银行信息*/
        supplier_bank_account = 64,
        /**入仓登记随附资料*/
        warehouse_record_attached = 65,
        /**入仓登记外观照片*/
        warehouse_record_appearance = 66,
        /**香港仓储协议*/
        hk_storage_contract = 67,
        /**打印模板*/
        print_template = 68,
        /**深圳送货单*/
        sz_delivery = 69,
        /**打印标签模板图片*/
        znlprint_model_files = 70,
        /**入库单明细照片*/
        receipt_order_line_photo = 71,
        /**内贸（电子）发票*/
        trade_electronic_invoice = 72,
        /**深圳送货单待打印附件*/
        sz_delivery_pdf = 73,
        /**深圳送货单签名*/
        sz_delivery_signature = 74,
        /**无单理货照片*/
        hk_receipt_info = 75,
        /**海关检验照片*/
        customs_vehicle_inspection = 76,
        /**成本录入*/
        register_cost = 77,
        /**提货文件*/
        hk_pickup_goods_files = 78
    }


    export interface IFileDetailView {

        Id?: NString

        FileName?: NString
        /**1 PDF   2图片
        *System.Int32*/
        FileType: number

        RelationId: number

        RelationType: UploadFileTypes

        Code?: NString

        CreatedAt?: NString

        IsHideFile?: boolean
    }


    export interface ISessionFileListParam {

        SessionId?: NString

        RelationType?: NString
    }


    export interface IDeleteUploadFileRequest {

        Id?: NString
    }


    export interface IUpdateHideParam {

        Id?: NString

        isHide: boolean
    }


    export interface IFileInfo {

        Id?: NString

        FileName?: NString
        /**1 PDF   2图片
        *System.Int32*/
        FileType: number
    }

    /**付汇水单附件
    *ZnlSoft.Scm.Core.ResultModels.FilesResult*/
    export interface IFilesResult {

        ImageFiles: Array<IFileInfo>
    }

    /**上传文件参数
    *ZnlSoft.Scm.Core.ResultModels.UploadFilesParam*/
    export interface IUploadFilesParam {
        /**付汇单ID
        *System.Int32*/
        Id: number
        /**文件ID
        *System.String*/
        FileId?: NString
        /**上传类型 23水单  3委托书
        *System.Int32*/
        Type: number
    }


    export const enum OCRWebApiType {
        None = 0,
        BarCode = 1,
        TextIn = 2,
        /**非api信息，手动录入*/
        ManualRemark = 3
    }


    export interface IPUB_UploadFileOCR {

        Id: number
        /**System.Guid*/
        FileId?: NString
        /**用了那些API
        *System.DateTime*/
        CreatedAt?: NString

        ApiType: OCRWebApiType

        Json?: NString
    }


    export interface IUpdateFieldParam {

        Id?: NString

        Value?: NString
    }


    export interface ICopyNewFileItem {

        SourceFileId?: NString

        FileName?: NString

        RelationType: UploadFileTypes
    }


    export interface ICopyUploadFilesParam {

        FileSessionId?: NString

        RelationId: number

        BlockDuplicateFile: boolean

        Files: Array<ICopyNewFileItem>
    }

}
export default UploadApi